import { Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../shared/components/component-base';
import { AttachmentList } from '../../../../shared/models/attachment';
import { RequestHistoryDto } from '../../model/request-history-dto';
import { WorkflowService } from '../../services/workflow-service';
import { ApiResponse } from '../../../../shared/models/api-response.model';


@Component({
  selector: 'request-history',
  templateUrl: './request-history.component.html'
})
export class RequestHistoryComponent extends BaseComponent  {
  @Input() requestId: string;
  requestHistoryList: RequestHistoryDto[]=[];
  lastOrder: string = "";
  currentOrder: string = "";

  constructor(
    public _workflowService?: WorkflowService,

  ) {
    super();
  }

   ngOnInit(): void {
    this.getRequestHistory();
  }
  attachmentList: AttachmentList[] = [];

  getRequestHistory() {
    
    this._workflowService.getRequestHistory(this.requestId).subscribe({
      next: (res: ApiResponse<RequestHistoryDto[]>) => {
        this.requestHistoryList = res.value;

        //for (var i = 0; i < this.requestHistoryList.length; i++) {
        //  for (var a = 0; a < this.requestHistoryList[i].attachments.length; a++) {
        //    let contentType = this.requestHistoryList[i].attachments[a].contentType;
        //    if (contentType.substr(0, 5) == 'image') {
        //      this.requestHistoryList[i].attachments[a].fileType = 'image';
        //    } else if (contentType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
        //      this.requestHistoryList[i].attachments[a].fileType = "word";
        //    else if (contentType == "application/pdf")
        //      this.requestHistoryList[i].attachments[a].fileType = "pdf";
        //  }
        //}
      },
      error: (error: Error) => {
        console.log(error.message);
      },
    });
  }






  //downloadFile(attachmentId: string) {
  //  this.attachementService.get(attachmentId)
  //    .subscribe({
  //      next: async (res: any) => {
  //        if (res != null) {
  //          let attach = res.value;
  //          if (attach.fileContent) {
  //            const base64File = attach.fileContent;
  //            const base64Response = await fetch(`data:` + attach.contentType + `;base64,${base64File}`);
  //            const blob = base64Response.blob();
  //            const url = window.URL.createObjectURL(await blob);
  //            window.open(url, "_blank");
  //          }
  //        }
  //      },
  //      error: (error: Error) => console.log(error.message)
  //    });
  //}


}
